/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-layout-padding-top',
  templateUrl: './theme-option-layout-padding-top.component.html',
  styleUrls: ['./theme-option-layout-padding-top.component.css']
})
export class ThemeOptionLayoutPaddingTopComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  showDetails: boolean;
  optionType: ThemeOptionType = 'layout_padding_top';

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: number, type?: ChartType) {
    this.themeOptions.setOption(this.optionType, value, type ? [type] : undefined);
  }

}
